import script from "./Bottom+InputModal.vue?vue&type=script&setup=true&lang=js"
export * from "./Bottom+InputModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__